import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";

export default function TagInput({ control, name, label }) {
  const [inputValue, setInputValue] = useState("");

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={[]}
      render={({ field: { value, onChange } }) => (
        <div>
          <label>{label}</label>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "4px" }}>
            {value.map((tag, i) => (
              <span
                key={i}
                style={{
                  padding: "4px 8px",
                  background: "#eee",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  fontSize: "14px"
                }}
              >
                {tag}
                <button
                  type="button"
                  onClick={() => onChange(value.filter((_, idx) => idx !== i))}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                >
                  ×
                </button>
              </span>
            ))}
            <input
              type="text"
              style={{ flexGrow: 1, minWidth: '100px' }}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if ((e.key === "Enter" || e.key === ",") && inputValue.trim() !== "") {
                  e.preventDefault();
                  onChange([...value, inputValue.trim()]);
                  setInputValue("");
                }
              }}
              placeholder="Type and press Enter"
              
            />
          </div>
        </div>
      )}
    />
  );
}